// Third-party
import React from 'react';

// Components
import DetailedDatesDisclaimer from './DetailedDatesDisclaimer';

// Utils
import { getDetailedAllocationsAsAtDates } from '../../../../utils/disclaimers/comparison';
import { formatMessageWithLocale } from '../../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
}

const ESGCarbonIntensityDisclaimer = ({ items, showItemNames, locale }: Props) => (
  <DetailedDatesDisclaimer
    globalPrefix={formatMessageWithLocale('Disclaimers.ESGCarbonIntensity', locale)}
    itemPrefix={formatMessageWithLocale('Common.On', locale)}
    itemDates={getDetailedAllocationsAsAtDates(items, locale)}
    showItemNames={showItemNames}
    locale={locale}
  />
);

export default ESGCarbonIntensityDisclaimer;
